export * from './base.service';
export * from './alert.service';
export * from './authentication.service';
export * from './users.service';
export * from './dashboard.service';
export * from './popup.service';
export * from './facilities.service';
export * from './roles.service';
export * from './general.service';
export * from './corporates.service';
export * from './reports.service';
export * from './account.service';
export * from './subscription.service';



// WEBPACK FOOTER //
// ./src/app/shared/services/index.ts